import endpoints from "../utils/endpoints";
import { removeEmpty } from "../utils/objectUtils";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";

export async function getPosBlundleServerList(params?: any) {
  let res = [
    {
      id: '',
      name: '',
      posBundleServerEnable: false,
      listPosIpadModel: [
        {
          identifier: '',
          model: '',
          compatible: false
        }
      ]
    }
  ]

  if (params) {
    params = removeEmpty(params)
  }

  await Api.get(endpoints.getPosBlundleServerList, { params }).then((response) => {
    if (response.status === 200) {
      if (response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    } else {
      notificationError('Could not get POS bundle server list')
    }

  }).catch((err: string) => {
    notificationError('Could not get POS bundle server list')
  })

  return res
}

export async function updatePosBlundleServerList(payload?: any) {
  await Api.post(endpoints.updatePosBundleServerList, payload).then((response) => {
    if (response.status === 200) {
      if (response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('POS bundle server list updated successfully')
      }
    } else {
      notificationError('Could not update POS bundle server list')
    }

  }).catch((err: string) => {
    notificationError('Could not update POS bundle server list')
  })

}
export async function disableIncompatiblePosBlundleServerList(payload?: any) {
  await Api.post(endpoints.disableIncompatiblePosBlundleServerList, payload).then((response) => {
    if (response.status === 200) {
      if (response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('POS bundle server list updated successfully')
      }
    } else {
      notificationError('Could not update POS bundle server list')
    }

  }).catch((err: string) => {
    notificationError('Could not update POS bundle server list')
  })

}